import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, NavLink, useNavigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './pages/Login';
import Calendar from './pages/Calendar';
import MyTimesheets  from './pages/MyTimesheets';
import toast from 'react-hot-toast';
import './index.css';

function TopNav() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [profileOpen, setProfileOpen] = React.useState(false);
  const handleLogout = () => { logout(); toast.success('Logged out.'); navigate('/login'); };

  return (
    <nav className="topnav">
      <div className="nav-logo">
        <div className="nav-logo-icon">TS</div>
        <span className="nav-logo-text">My Timesheet</span>
      </div>
      <div className="nav-links">
        <NavLink to="/"            end className={({isActive}) => `nav-link ${isActive?'active':''}`}>📅 Calendar</NavLink>
        <NavLink to="/timesheets"      className={({isActive}) => `nav-link ${isActive?'active':''}`}>📋 My Submissions</NavLink>
      </div>
      <div className="nav-right">
        <div style={{display:'flex',alignItems:'center',gap:8}}>
          <div className="avatar">{user?.name?.charAt(0)}</div>
          <div style={{lineHeight:1.3}}>
            <div style={{fontSize:12.5,fontWeight:600}}>{user?.name}</div>
            <div style={{fontSize:11,color:'#6b7280'}}>{user?.department}</div>
          </div>
        </div>
        <div style={{ position:'relative', marginLeft:6 }}>
          <button
            onClick={() => setProfileOpen(p => !p)}
            style={{ display:'flex', alignItems:'center', gap:6, background:'none', border:'1px solid #2a2d3a', borderRadius:8, padding:'5px 10px', cursor:'pointer', color:'#e5e7eb', fontSize:13, fontFamily:'inherit' }}
          >
            ⋮
          </button>
          {profileOpen && (
            <div style={{ position:'absolute', top:'calc(100% + 6px)', right:0, background:'#1a1d27', border:'1px solid #2a2d3a', borderRadius:10, overflow:'hidden', minWidth:180, boxShadow:'0 8px 24px rgba(0,0,0,.4)', zIndex:200 }}>

              <button
                onClick={() => { setProfileOpen(false); handleLogout(); }}
                style={{ display:'flex', alignItems:'center', gap:10, width:'100%', padding:'11px 16px', background:'none', border:'none', color:'#ef4444', fontSize:13, cursor:'pointer', fontFamily:'inherit', textAlign:'left' }}
                onMouseEnter={e => e.currentTarget.style.background='rgba(239,68,68,.08)'}
                onMouseLeave={e => e.currentTarget.style.background='none'}
              >
                ⏻ Logout
              </button>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
}

function AppLayout({ children }) {
  return (
    <div className="app">
      <TopNav />
      <div className="main">{children}</div>
    </div>
  );
}

function Guard({ children }) {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  return <AppLayout>{children}</AppLayout>;
}

function Public({ children }) {
  const { user } = useAuth();
  return user ? <Navigate to="/" replace /> : children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login"       element={<Public><Login /></Public>} />
      <Route path="/"            element={<Guard><Calendar /></Guard>} />
      <Route path="/timesheets"     element={<Guard><MyTimesheets  /></Guard>} />
      <Route path="*"            element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
        <Toaster position="top-right" toastOptions={{ style:{ background:'#1a1d27', color:'#e5e7eb', border:'1px solid #2a2d3a', borderRadius:10, fontSize:13 }, success:{ iconTheme:{ primary:'#10b981', secondary:'#1a1d27' }}, error:{ iconTheme:{ primary:'#ef4444', secondary:'#1a1d27' }}}} />
      </BrowserRouter>
    </AuthProvider>
  );
}